import { render, staticRenderFns } from "./SkeletonSku.vue?vue&type=template&id=f0424cce&"
import script from "./SkeletonSku.vue?vue&type=script&lang=ts&"
export * from "./SkeletonSku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports